import { ReactNode } from 'react'
import { LogoWordmark } from './Logo'

export function Header({ children }: { children?: ReactNode }) {
  return (
    <header className="wrap site-header">
      <LogoWordmark />
      {children ? <nav>{children}</nav> : null}
    </header>
  )
}
